<template>
  <div class='title-container title-container-cp'>
    <div class="columns">
      <div class="column is-7 tbl client-numbers">
        <div class="columns">
          <div class="column is-stats">
            <div class="first-item">
              <span>Jobs</span>
            </div>
          </div>
          <div class="column is-stats">
            <div class="request-title">
              <span class="green">{{statsData.scheduled}}</span> scheduled
            </div>
          </div>
          <div class="column is-stats">
            <div class="request-title">
              <span class="red">{{statsData.cancelled}}</span> cancelled
            </div>
          </div>
          <div class="column is-stats">
            <div class="request-title">
              <span class="blue">{{statsData.completed}}</span> completed
            </div>
          </div>
          <div class="filter">
            <div class='custom-select stats-dropdown'>
              <div class="dropdown">
                <div class="dropdown-toggle" type="button" id="drop-down-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-html="selectedParam">
                </div>
                <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <b class="custom-caret"></b>
                </div>
                <div class="dropdown-menu" aria-labelledby="drop-down-menu">
                  <div v-for="(option, index) in options" :key="index" @click.prevent='setSelectedParam(option)'>
                    <div class='custom-option' v-html="option.name"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      <div class="column is-stats">
        <!-- <div class="request-title">
          <span>{{statsData.total}}</span> total
        </div> -->
      </div>
    </div>
  </div>
  <div class="column is-5 client-options">
    <div class="columns title-buttons">
      <div class='table-msg table-refresh'>
        <span>{{tableRefreshMsg}}</span>
      </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      options: [
        {
          value: 'today',
          name: "&nbsp;Today"
        },
        {
          value: 'week',
          name: "&nbsp;This Week"
        },
        {
          value: 'month',
          name: "&nbsp;This Month"
        },
        // {
        //   value: 'year',
        //   name: "&nbsp;This Year"
        // },
      ],
    }
  },

  computed: {
    ...mapState('stats', {
      selectedParam: state => state.selectedParam,
      statsData: state => state.statsData
    }),

    ...mapState('nav', {
      newRequestSelected: state => state.newRequestSelected,
    }),

    ...mapState('datatable', {
      tableRefreshMsg: state => state.tableRefreshMsg
    }),
  },

  methods: {
    setSelectedParam: function(val){
      //console.log(val);
      VueStore.dispatch('stats/setSelectedStats', val.value);
      sessionStorage.setItem('ACTIVE-STATS', val.value);
    }
  },

  mounted(){
    // Check local storage for active tab otherwise use 1st item in the tabs array
    if(typeof sessionStorage.getItem("ACTIVE-STATS") !== 'undefined' && sessionStorage.getItem("ACTIVE-STATS") !== null){
      VueStore.dispatch('stats/setSelectedStats', sessionStorage.getItem("ACTIVE-STATS"))
    } else {
      // default to week
      VueStore.dispatch('stats/setSelectedStats', 'week');
    }
  }
}
</script>

<style>
.table-msg {
    border-right: none !important;
}
</style>
